<div
  class="esim-status-tag"
  [class.esim-status-tag-t2]="theme() === GbTheme.ThemeTwo && position() === 'left'"
  [class.active]="status() === InternalSimStates.Active"
  [class.inactive]="status() === InternalSimStates.InActive"
  [class.archived]="status() === InternalSimStates.Deleted"
>
  <span
    class="status-icon"
    [class.active]="status() === InternalSimStates.Active"
    [class.inactive]="status() === InternalSimStates.InActive"
    [class.archived]="status() === InternalSimStates.Deleted"
  ></span>
  <span
    class="primary-font-medium status-text"
    [class.active]="status() === InternalSimStates.Active"
    [class.inactive]="status() === InternalSimStates.InActive"
    [class.archived]="status() === InternalSimStates.Deleted"
  >
    {{ 'my_esims.status.' + (displayKey() | lowercase) | translate }}
  </span>
</div>
